module.exports = __webpack_public_path__ + "img/goal_placeholder.c60c25a5.png";